import { Input, InputProps } from "@chakra-ui/react";
import { useState } from "react";
import { debounceTime, tap } from "rxjs";
import { useSubscribeObservable } from "./useSubscribeObservable";
import { useToObservable } from "./useToObservable";

interface DebouncedInputProps extends InputProps {
  setValue: (value: string) => void;
  time: number;
}

export const DebouncedInput = ({
  setValue,
  time,
  ...inputProps
}: DebouncedInputProps) => {
  const [state, setState] = useState("");
  const state$ = useToObservable(state);

  // Subscribe to observable
  useSubscribeObservable(
    state$.pipe(
      debounceTime(time),
      tap((value) => {
        setValue(value);
      })
    )
  );

  return (
    <Input
      {...inputProps}
      value={state}
      onChange={(e) => setState(e.target.value)}
    />
  );
};
